import { Component, inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../auth/services/auth.service';
import { AuthApiService } from '../../auth/services/auth-api.service';
import { ToastNotificationService } from '../../../notifications/services/toast-notification.service';
import { ToastNotificationType } from '../../../notifications/models/toast-notification-type';
import { LanguageService, SupportedLanguage } from '../../../shared/services/translations/language.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-not-allowed',
  imports: [TranslateModule, CommonModule],
  templateUrl: './not-allowed.component.html',
  styleUrl: './not-allowed.component.css'
})
export class NotAllowedComponent {

  private authService = inject(AuthService);
  private authApiService = inject(AuthApiService);
  toastNotificationService = inject(ToastNotificationService);
  translate = inject(TranslateService);
  languageService = inject(LanguageService);

  isLanguageOpen = false;

  toggleLanguageDropdown() {
    this.isLanguageOpen = !this.isLanguageOpen;
  }

  changeLanguage(lang: SupportedLanguage) {
    this.languageService.changeLanguage(lang);
    this.isLanguageOpen = false;
  }

  logout() {
    this.authApiService.logout().subscribe({
      next: (response) => {
        this.authService.logout();
      },
      error: (err) => {
        this.toastNotificationService.createNotification(
          this.translate.instant('common.errors.generic_request_failed'),
          ToastNotificationType.ERROR,
        );
      }
    });
  }
}
